export default __webpack_public_path__ + "static/media/filter.7bd73cdd.svg";